module.exports = __webpack_public_path__ + "img/Stahl-Zäune1.7858990c.png";